

export class StorageDaysOutputWithOutStatus implements IStorageDaysOutputWithOutStatus {
    /** The auto-generated id of the storage days master */
    storage_days_id!: number;
    /** The storage days name with 255 character limit */
    storage_days_name!: string;

    constructor(data?: IStorageDaysOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storage_days_id = _data["storage_days_id"];
            this.storage_days_name = _data["storage_days_name"];
        }
    }

    static fromJS(data: any): StorageDaysOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StorageDaysOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storage_days_id"] = this.storage_days_id;
        data["storage_days_name"] = this.storage_days_name;
        return data; 
    }
}

export interface IStorageDaysOutputWithOutStatus {
    /** The auto-generated id of the storage days master */
    storage_days_id: number;
    /** The storage days name with 255 character limit */
    storage_days_name: string;
}

